export default "__VITE_ASSET__BW3lRtyo__"